import { datalabWithTokenHttp, type TDatalabHttpConfig } from '@dbl/services/common';
import { sanitizeReportDimensionParams } from '@/pages/datalab/utils/utils';

import type { IReportDimensionInfoRequest } from './types';

/**
 * 获取报表筛选器维度值（分页/关键字/级联 filters）。
 *
 * 原始实现：`src/pages/datalab/services/customDashboard.ts` -> getReportDimensionInfo
 * 原始目录：`services/dimension/`
 */
export function getReportDimensionInfo(
  params: IReportDimensionInfoRequest,
): Promise<unknown> {
  const nextParams = { ...params };

  if (Array.isArray(nextParams.filters)) {
    nextParams.filters = nextParams.filters.map(filter => {
      if (!filter) {
        return filter;
      }
      return {
        ...filter,
        value:
          filter?.filterType === 'string' && filter?.is_full
            ? []
            : filter?.value,
        table_code: filter?.table_code || 't0',
      };
    });
  }

  const requestData = sanitizeReportDimensionParams(nextParams);

  return datalabWithTokenHttp({
    url: '/api/v1/datalab/getReportDimensionInfo',
    method: 'post',
    data: {
      ...requestData,
      request_time: new Date().toISOString(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  } as TDatalabHttpConfig);
}
